/* global axios */
import ApiClient from './ApiClient';

class Mres3RuntimeAPI extends ApiClient {
  constructor() {
    super('mres3_connections', { accountScoped: true });
  }

  show(id) {
    return axios.get(`${this.url}/${id}/runtime`);
  }

  save(id, settings) {
    return axios.put(`${this.url}/${id}/runtime`, { settings });
  }

  bind(id, payload) {
    return axios.post(`${this.url}/${id}/runtime/bindings`, payload);
  }

  revoke(id, bindingId) {
    return axios.post(`${this.url}/${id}/runtime/bindings/${bindingId}/revoke`);
  }
}

export default new Mres3RuntimeAPI();
